import styled from 'styled-components';

const MessageContainer = ({ incomingMessage, children }) => {
    return (
        <StyledMessageContainer incomingMessage={incomingMessage}>
            {children}
        </StyledMessageContainer>
    );
};

const StyledMessageContainer = styled.div`
    display: flex;
    cursor: pointer;
    color: #fff;
    font-size: 1rem;
    gap: 8px;
    margin: 0 0.5em;
    flex-direction: ${props => props.incomingMessage ? 'row' : 'row-reverse'};
`;

export default MessageContainer;
